<template>
    <button
        class="customLike rounded-full shadow-xl w-10 h-10 flex items-center justify-center duration-300 ease-in delay-200 likebutton"
        @click.stop :class="[
            background,
            liked ? '!bg-white/80' : '',
            inline ? 'relative static' : 'absolute right-2 top-2'
        ]" :title="$t('like')">
        <input @click.stop="toggleLike(id)" type="checkbox" :id="'customLike' + id" v-model="liked" />
        <label :for="'customLike' + id">
            <svg viewBox="0 0 24 24" class="w-7 h-7 heart-svg" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" class="heart"
                    d="M12 20a1 1 0 0 1-.437-.1C11.214 19.73 3 15.671 3 9a5 5 0 0 1 8.535-3.536l.465.465.465-.465A5 5 0 0 1 21 9c0 6.646-8.212 10.728-8.562 10.9A1 1 0 0 1 12 20z" />
                <circle class="main-circ" fill="#E2264D" opacity="0" cx="12" cy="12" r="12" />
                <g class="grp7" opacity="0" transform="translate(0 1)">
                    <circle class="oval1" cx="2" cy="6" r="2" />
                    <circle class="oval2" cx="5" cy="2" r="2" />
                </g>
                <g class="grp6" opacity="0" transform="translate(0 15)">
                    <circle class="oval1" cx="2" cy="7" r="3" />
                    <circle class="oval2" cx="3" cy="2" r="3" />
                </g>
                <g class="grp3" opacity="0" transform="translate(20 10)">
                    <circle class="oval2" cx="2" cy="7" r="2" />
                    <circle class="oval1" cx="4" cy="2" r="2" />
                </g>
                <g class="grp2" opacity="0" transform="translate(20 2)">
                    <circle class="oval2" cx="5" cy="6" r="2" />
                    <circle class="oval1" cx="2" cy="2" r="2" />
                </g>
                <g class="grp5" opacity="0" transform="translate(8 22)">
                    <circle class="oval1" cx="6" cy="5" r="2" />
                    <circle class="oval2" cx="2" cy="2" r="2" />
                </g>
                <g class="grp4" opacity="0" transform="translate(15 20)">
                    <circle class="oval1" cx="6" cy="5" r="3" />
                    <circle class="oval2" cx="2" cy="2" r="3" />
                </g>
                <g class="grp1" opacity="0" transform="translate(10)">
                    <circle class="oval1" cx="2.5" cy="3" r="2" />
                    <circle class="oval2" cx="7.5" cy="2" r="2" />
                </g>
            </svg>
        </label>
    </button>
</template>
  

<script>
import VueCookies from 'vue-cookies'

export default {
    name: 'likebutton',
    props: {
        id: [String, Number],
        background: String,
        color: String,
        inline: { type: Boolean, default: false }
    },
    data() {
        return {
            liked: false
        }
    },
    methods: {
        toggleLike(item) {
            var cookies = VueCookies.get('liked') ? VueCookies.get('liked') : [];

            console.log("togglelike");
            if (Object.values(cookies).includes(item)) {
                cookies = cookies.filter(function (a) { return a !== item })
                VueCookies.set('liked', Object.values(cookies), '30d')
            } else {
                cookies.push(item);
                VueCookies.set('liked', cookies, '30d')
            }
        }
    },
    created() {
        if (VueCookies.get('liked')) {
            if (Object.values(VueCookies.get('liked')).includes(this.id)) {
                this.liked = true;
            }
        }
    }
}
</script>